import useResponsive from "./useResponsive";

export default function useBasePadding() {
  const { isPc } = useResponsive();
  // const GOLBAL_PADDING = isMobile ? "60px" : isTablet ? "240px" : "320px";
  const GOLBAL_PADDING = isPc ? "320px" : "60px";
  return { GOLBAL_PADDING };
}
